import { useState } from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from '@/components/ui/card'
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell
} from '@/components/ui/table'
import { ButtonType } from '@/components/lib/Button'
import { v4 as uuidv4 } from 'uuid'
import { Button } from '@/components/ui/button'
import { PenLine, Trash2, Plus } from 'lucide-react'
import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'
import { removeItemVariant } from '@/redux/slice/essential-menu-slice/variants-slice'
import FormInputField from '@/components/lib/from-input-field'
import { Input } from '@/components/ui/input'
import { X } from 'lucide-react'
import CreateItem from '@/components/dialog/menu-manage/common-dialog/create-item'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { toast } from "react-hot-toast";
import { setItemVariants } from '@/redux/slice/essential-menu-slice/variants-slice'
import {
  fetchSingleComboMeal,
  updateExistingComboMeal
} from '@/redux/slice/menu-manage-slice/combo-meal-slice'
import { Loader2 } from 'lucide-react'

function Step2 ({ form, dayTimes, setDayTimes, comboDays, item_id }) {
  const [openDialog, setOpenDialog] = useState(false)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const discount_price = form.watch('discount_price')
  const combo_days = form.watch('combo_days')
  const [enableDiscount, setEnableDiscount] = useState(false)
  const [enableDayTime, setEnableDayTime] = useState(true)
  const { itemVariants } = useSelector(state => state.essentialMenu.variants)
  const { days } = useSelector(state => state.utility.day)

  useEffect(() => {
    const fetchSingleItem = async () => {
      try {
        const res = await dispatch(fetchSingleComboMeal(item_id))
        if (fetchSingleComboMeal.fulfilled.match(res)) {
          const item = res?.payload?.combo_items
          dispatch(setItemVariants(item || []))
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchSingleItem()
  }, [])

  const handleItemUpdate = async (payload, actionType = 'add') => {
    if (!payload) return
    setLoading(true)
    let allItem = [...itemVariants]
    if (actionType === 'add') {
      allItem = [...itemVariants, payload]
    } else if (actionType === 'remove') {
      allItem = itemVariants.filter(item => item.unique_id !== payload)
    }
    form.setValue('combo_items', allItem)
    try {
      const res = await dispatch(
        updateExistingComboMeal({
          id: item_id,
          data: {
            status: `${
              form.watch('type') === 'update' ? form.watch('status') : 'draft'
            }`,
            combo_items: allItem
          }
        })
      )
      if (updateExistingComboMeal.fulfilled.match(res)) {
        // toast.success("Combo updated successfully.");
      } else {
        // toast.error(res?.payload || "Failed to update the combo.");
      }
    } catch (error) {
      toast.error('Failed to update the combo meal.')
      setLoading(false)
    }

    setLoading(false)
  }

  // Handle Day & Time

  const addDayTime = dayName => {
    const dayObj = days.find(d => d.name === dayName)
    if (!dayObj) return
    if (dayTimes.some(dt => dt.day_id === dayObj.id)) return // avoid duplicates

    setDayTimes([
      ...dayTimes,
      {
        day_id: dayObj.id,
        // start_time: "09:00",
        // end_time: "17:00",
        is_active: true
      }
    ])
  }

  const updateDayTime = (i, field, value) => {
    const updated = [...dayTimes]
    updated[i][field] = value
    setDayTimes(updated)
  }

  const removeDayTime = i => {
    setDayTimes(dayTimes.filter((_, idx) => idx !== i))
  }

  useEffect(() => {
    const mappedItems = itemVariants?.map(item => ({
      item_id: item.item_id,
      item_type: item.item_type,
      variant_id: item.variant_id,
      file_manager_id: item.file_manager_id,
      quantity: item.quantity,
      price: item.price ?? null
    }))

    form.setValue('combo_items', mappedItems)
    const mappedDays = dayTimes.map(dt => ({
      day_id: dt.day_id,
      // day: days.find((d) => d.id === dt.day_id)?.name || "",
      start_time: dt.start_time,
      end_time: dt.end_time,
      is_active: true
    }))

    form.setValue('combo_days', mappedDays)
  }, [dayTimes, itemVariants])

  const handleRemove = async id => {
    await dispatch(removeItemVariant(id))
    await handleItemUpdate(id, 'remove')
    toast.success('Combo item removed successfully')
  }

  useEffect(() => {
    setEnableDiscount(!!discount_price)
    setEnableDayTime(Array.isArray(combo_days) && combo_days.length > 0)
  }, [discount_price, combo_days])

  return (
    <Card className='max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite'>
      <CardHeader>
        <CardTitle>
          {' '}
          {form.watch('type') == 'update'
            ? 'Update Combo/Set/Offer- Meal'
            : 'Add New Combo/Set/Offer- Meal'}{' '}
        </CardTitle>
        <CardDescription className='text-cyellow'>
          Item name: {form.watch('name') || 'No name'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {/* Items Section */}
        <div className='flex justify-between items-center mb-4'>
          <h2 className='text-lg font-semibold'>Add Meal Item</h2>
          <ButtonType
            onClick={() => setOpenDialog(true)}
            className='bg-cgreen/70 text-cwhite flex flex-shrink-0'
          >
            <span className='flex items-center'>
              <Plus className='w-4 h-4 mr-1' /> Add New Item
            </span>
          </ButtonType>
        </div>

        <div className='relative'>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Item Name</TableHead>
                <TableHead>Image</TableHead>
                <TableHead>Quantity</TableHead>
                <TableHead>Price</TableHead>
                <TableHead>In Price</TableHead>
                <TableHead>Out Price</TableHead>
                <TableHead className='text-right'>Action</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {itemVariants && itemVariants.length > 0 ? (
                itemVariants.map((item, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      {item?.item_name ||
                        item?.menu_item?.name ||
                        'Data not available'}
                    </TableCell>
                    <TableCell>
                      {item?.file_manager_url ? (
                        <img
                          src={item?.file_manager_url}
                          alt={item?.item_name}
                          className='w-12 h-12 rounded'
                        />
                      ) : (
                        'No Image'
                      )}
                    </TableCell>
                    <TableCell>{item?.quantity ?? 'N/A'}</TableCell>
                    <TableCell>
                      {item?.price !== undefined ? `£ ${item?.price}` : 'N/A'}
                    </TableCell>
                    <TableCell>
                      {item?.in_price !== undefined
                        ? `£ ${item?.in_price}`
                        : 'N/A'}
                    </TableCell>
                    <TableCell>
                      {item?.out_price !== undefined
                        ? `£ ${item?.out_price}`
                        : 'N/A'}
                    </TableCell>
                    <TableCell className='text-right'>
                      <span className='flex items-center justify-end gap-3'>
                        <Trash2
                          onClick={() => handleRemove(item?.unique_id)}
                          className='w-4 h-4 text-cred cursor-pointer'
                        />
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} className='text-center'>
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {/* Loading overlay */}
          {loading && (
            <div className='absolute inset-0 bg-black/40 flex justify-center items-center z-10'>
              <Loader2 className='animate-spin' />
            </div>
          )}
        </div>

        {/* Price */}
        <div className='mt-5'>
          <FormInputField
            name='price'
            style='bg-cblack7'
            placeholder={'Price'}
            form={form}
            type='text'
            label={'Price'}
          />
        </div>
        {/* Discount Price */}
        <div className='space-y-2 mt-5'>
          <div className='flex items-center gap-2'>
            <Switch
              checked={enableDiscount}
              onCheckedChange={setEnableDiscount}
              className='data-[state=unchecked]:bg-neutral-500'
            />
            <Label>Discount Price</Label>
          </div>
          {enableDiscount && (
            <FormInputField
              name='discount_price'
              style='bg-cblack7'
              placeholder={'Discount Price'}
              form={form}
              type='text'
            />
          )}
        </div>

        {/* Day & Time */}
        <div className='flex items-center gap-2 mt-5'>
          <Switch
            checked={enableDayTime}
            onCheckedChange={setEnableDayTime}
            className='data-[state=unchecked]:bg-neutral-500'
          />
          <Label>Days</Label>
        </div>

        {enableDayTime && (
          <div className='mt-3 space-y-4'>
            {/* Day Buttons */}
            <div className='flex flex-wrap gap-2'>
              {days.map(d => {
                let isDay = dayTimes.some(dt => dt.day_id === d.id)
                return (
                  <ButtonType
                    key={d.id}
                    size='sm'
                    onClick={() => {
                      if (isDay) {
                        // Unselect (remove) the day
                        setDayTimes(dayTimes.filter(dt => dt.day_id !== d.id))
                      } else {
                        // Select (add) the day
                        addDayTime(d.name)
                      }
                    }}
                    className={`${
                      isDay ? '!bg-cyellow !text-black' : ''
                    } !bg-cblack7 text-cwhite F`}
                  >
                    {d.short_name}
                  </ButtonType>
                )
              })}
            </div>
          </div>
        )}
      </CardContent>

      {/* Dialog */}
      <CreateItem
        title={'Add Meal Item'}
        isOpen={openDialog}
        onClose={() => setOpenDialog(false)}
        onSuccess={item => handleItemUpdate(item, 'add')}
      />
    </Card>
  )
}

export default Step2
